import { API } from "../auth/authApi";

export const getNotificationsApi = (page = 1, limit = 10) => {
  return API.get(`/notification/all?page=${page}&limit=${limit}`);
};

export const getSponsorNotificationsApi = (page = 1, limit = 10) => {
  return API.get(`/notification/user?page=${page}&limit=${limit}`);
};
export const getAnnouncementsApi = (page = 1, limit = 10) => {
  return API.get(`/notification/announcement?page=${page}&limit=${limit}`);
};

export const createNotificationApi = (data) => {
  return API.post("/notification", data, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};